import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import VerificationInput from "react-verification-input";
import { useUserContext } from "../../context/user_context";
import { AuthServiceContext } from "../../services/auth/authService";
import Countdown from "react-countdown";
import Cookies from "js-cookie";
import { UserServiceContext } from "../../services/user/userService";
import { CommonServiceContext } from "../../services/common/commonService";

const TwoFactorModal = ({
  formData,
  askSms,
  setCreateEventModal,
  setFormData,
  authType,
  resetCaptcha,
  clearFormData,
  closeAlert,
  isLoggedIn,
  packageData,
  setAlertConfig,
  setPackageModal,
}) => {
  const { captchaState, setCaptchaState } = useUserContext();
  const { register, auth2Factor } = useContext(AuthServiceContext);
  const { addDeliveryOrder, addDeliveryOrder4User, sendSms } =
    useContext(CommonServiceContext);
  const { changePhone } = useContext(UserServiceContext);
  const [passed, setPassed] = useState(false);
  const [smsCodeError, setSmsCodeError] = useState("");
  const [currentTimeIndex, setCurrentTimeIndex] = useState(0);
  const navigate = useNavigate();
  // const changePhone = async (data) => {
  //   console.log(data);
  // };
  const handlePinChange = (value) => {
    setFormData({ ...formData, smsCode: value });
  };

  //console.log(setCreateEventModal);

  const handleComplete = () => {
    setPassed(true);
  };

  const handleClick = () => {
    setPassed(false);
    setCurrentTimeIndex(currentTimeIndex + 1);
  };

  // useEffect(() => {
  //   if (formData) {
  //     console.log(formData);
  //   }
  // }, [formData]);

  const Register = async () => {
    const response = await register(formData);

    if (response && !response.success) {
      switch (response.message) {
        case "User not Confirmed":
          setCreateEventModal();
          navigate("/user-confirmation");
          //todo: show error message
          break;
        case "recaptcha":
          setCreateEventModal();
          setCaptchaState({ ask: true, token: captchaState.token });
          break;
        case "SmsCode":
          setFormData({ ...formData, smsCode: "" });
          setSmsCodeError("არასწორი კოდი");
          break;
        default:
          return;
      }
    }
  };

  const login = async () => {
    const tk = Cookies.get("Token");
    const credentials = { smsCode: formData.smsCode, token: tk };
    // console.log(credentials);
    const response = await auth2Factor(credentials);
    if (response && !response.success) {
      switch (response.message) {
        case "User not Confirmed":
          setCreateEventModal();
          navigate("/user-confirmation");
          //todo: show error message
          break;
        case "recaptcha":
          setCreateEventModal();
          setCaptchaState({ ask: true, token: captchaState.token });
          break;
        case "SmsCode":
          setFormData({ ...formData, smsCode: "" });
          setSmsCodeError("არასწორი კოდი");
          break;
        default:
          return;
      }
    }
  };

  const deliveryRequest = async () => {
    if (packageData.orderInfo.packageTypeId == 1) {
      packageData.pieces = [];
    }

    packageData.sender.contactName = !packageData.sender.contactName
      ? packageData.sender.name
      : packageData.sender.contactName;


    packageData.receiver.contactName = !packageData.receiver.contactName
      ? packageData.receiver.name
      : packageData.receiver.contactName;


      const data = {
      ...packageData,
      smsCode: formData.smsCode,
      recaptchaCode: captchaState.token,
      mobilePhone: formData.mobilePhone,
    };
    //console.log(data);
    //setCreateEventModal(false);
    //setPackageModal();
    // setAlertConfig({
    //   show: true,
    //   title: "გაფრთხილება",
    //   text: "გსურთ ფაქტურის შექმნა?",
    //   icon: "warning",
    // }); // Clear alert

    const response = isLoggedIn
      ? await addDeliveryOrder4User(data)
      : await addDeliveryOrder(data);

    //console.log(response);

    if (response && response.data && response.data.success) {
      setCreateEventModal(false);
      setPackageModal(response.data.trackingNumber,response.data.docUrl);
    } else {
      setCreateEventModal(false);
      setAlertConfig({
        show: true,
        title: "შეცდომა",
        text: response?.data?.message,
        icon: "error",
      }); // Clear alert
    }
  };

  const handleChangePhone = async () => {
    const credentials = {
      phone: formData.mobilePhone,
      smsCode: formData.smsCode,
    };

    const response = await changePhone(credentials);
    //console.log(response);
    //return;
    if (response && !response.data.success) {
      switch (response.data.message) {
        case "User not Confirmed":
          setCreateEventModal();
          navigate("/user-confirmation");
          break;
        case "recaptcha":
          resetCaptcha();
          setCreateEventModal();

          //setCaptchaState({ ask: true, token: captchaState.token });
          break;
        case "SmsCode":
          setFormData({ ...formData, smsCode: "" });
          setSmsCodeError("არასწორი კოდი");
          break;
        default:
          return;
      }
    } else {
      //
      //console.log("success");
      setFormData({ ...formData, smsCode: "" });
      closeAlert();
      resetCaptcha();
      setCreateEventModal(false);
      //navigate("/account-setting");
    }
  };

  useEffect(() => {
    if (formData && formData.smsCode && formData.smsCode.length === 4) {
      //submit form
      if (authType === "register") {
        Register();
      }
      if (authType === "login") {
        //login
        login();
      }
      if (authType === "changePhone") {
        handleChangePhone();
      }
      if (authType === "deliveryRequest") {
        deliveryRequest();
        //console.log("deliveryRequest");
        //console.log(formData);
      }
    }
  }, [formData.smsCode, authType]);

  // const SmsSend = async () => {
  //   if (askSms) {
  //     const resp = await sendSms({
  //       mobilePhone: formData.mobilePhone,
  //       recaptchaCode: captchaState.token,
  //     });
  //     return resp;
  //     //setFormData({ ...formData, recaptchaCode: captchaState.token });
  //   }
  //   return "asdasd";
  // };

  // useEffect(() => {
  //   if (askSms) {
  //     const response = SmsSend();
  //     console.log(response);
  //   }
  // }, [askSms]);

  // useEffect(() => {
  //   SmsSend();
  // }, [captchaState, send]);

  // useEffect(() => {
  //   setCaptchaState({ ask: true, token: captchaState.token });
  // }, []);

  return (
    <>
      <div
        className={`fixed p-15 w-full max-w-[800px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]`}
      >
        <div className="py-10 md:px-10 px-[7px] bg-card-color rounded-lg shadow-shadow-lg">
          <div className="my-10 lg:px-20 md:px-10 px-[7px] md:max-h-[80svh] max-h-[60svh] overflow-auto custom-scrollbar">
            <div className="text-[24px]/[30px] font-medium mb-2">
              {askSms && (
                <>
                  <div
                    className="flex mb-20"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <h2>
                      {captchaState.ask
                        ? "გთხოვთ მონიშნოთ ველი"
                        : "SMS კოდი გამოგზავნილია ნომერზე"}
                    </h2>
                    <p>შეიყვანეთ SMS კოდი</p>
                  </div>
                  <div
                    className="flex mb-20"
                    style={{ justifyContent: "center", alignItems: "center" }}
                  >
                    <VerificationInput
                      validChars="0-9"
                      autoFocus={true}
                      onChange={(value) => handlePinChange(value)}
                      length={4}
                    />
                  </div>
                  {smsCodeError && (
                    <div
                      className="flex mb-20"
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <div className="text-danger text-[14px]/[20px]">
                        {smsCodeError}
                      </div>
                    </div>
                  )}
                  <div
                    className="flex mb-20"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <h2>კოდი აქტიურია 3 წუთი</h2>
                    <div className="countdown">
                      <Countdown
                        key={currentTimeIndex}
                        onComplete={handleComplete}
                        date={Date.now() + 3 * 60 * 1000}
                      />
                    </div>
                    <button
                      className="btn btn-primary"
                      disabled={!passed}
                      onClick={handleClick}
                    >
                      ხელახლა გაგზავნა
                    </button>
                  </div>
                </>
              )}

              {/* {captchaState.ask && (
                <>
                  <div
                    className="flex mb-20"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <h2>
                      {captchaState.ask
                        ? "გთხოვთ მონიშნოთ ველი"
                        : "SMS კოდი გამოგზავნილია ნომერზე"}
                    </h2>
                    <div
                      className="auth-err-cont"
                      style={{ marginTop: "10px" }}
                    >
                      <RecaptchaComponent />
                    </div>
                  </div>
                </>
              )} */}
              {/* <div
                className="flex mb-20"
                style={{ justifyContent: "center", alignItems: "center" }}
              >
                <VerificationInput
                  validChars="0-9"
                  autoFocus={true}
                  name="smsCode"
                  onChange={(value) => handlePinChange(value)}
                  length={4}
                /> 
               </div> */}
            </div>
          </div>
        </div>
      </div>
      <div
        onClick={() => setCreateEventModal(false)}
        className={`contents-[] fixed z-[5] w-full h-full left-0 top-0 bg-black-50 backdrop-blur-[2px]`}
      ></div>
    </>
  );
};

export default TwoFactorModal;
